module.exports = __webpack_public_path__ + "static/media/icon-shorttime-withoutpay.05c0fd24.svg";